import glossary from '@/fixture/glossary'

export default {
  name: 'oz-card-title',

  props: {
    address: { type: String },
    unitType: { type: Array },
    size: { type: Array },
    bedrooms: { type: Array },
    businessType: { type: Array },
  },

  computed: {
    unitTypeName () {
      return glossary.items.unitType.items[this.unitType[0]].singular
    },

    sizeText () {
      let text = ''
      if (this.size.length === 1) {
        text = `de ${[this.size]} m²`
      } else if (this.size.length > 1) {
        text = `de ${Math.min(...this.size)}-${Math.max(...this.size)} m²`
      }

      return text
    },

    bedroomText () {
      let text = ''
      if (this.bedrooms.length === 1) {
        if (this.bedrooms[0] === 0) {
          text = ''
        } else if (this.bedrooms[0] === 1) {
          text = 'com 1 quarto'
        } else {
          text = `com ${[this.bedrooms]} quartos`
        }
      } else if (this.bedrooms.length > 1) {
        text = `com ${Math.min(...this.bedrooms)}-${Math.max(...this.bedrooms)} quartos`
      }

      return text
    },

    businessTypeName () {
      const business = this.businessType[0].businessType
      return (glossary.items.businessType.items[business].singular).toLowerCase()
    },
  },
}
